/** @format */
import {TFunction} from 'i18next';

import {getSpentNumber} from 'features/tariffs/helpers/getSpentNumber';

const getBudgetDescription = (
  spentMin: number | null,
  spentMax: number | null,
  t: TFunction,
): string => {
  if (spentMax === null && spentMin === null) {
    return '';
  }

  const preposition = spentMax === null ? 'более' : 'до';

  // Если spentMax === null, то берем spentMin. В противном случае берем spentMax.
  const {spent, isMillion} =
    spentMax === null ? getSpentNumber(spentMin) : getSpentNumber(spentMax);

  return isMillion
    ? t('{{preposition}} {{spent}} млн ₽/месяц', {preposition, spent})
    : t('{{preposition}} {{spent}} ₽/месяц', {preposition, spent});
};

export {getBudgetDescription};
